// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.soft-datepicker {
  border: 0.0625rem solid #d2d6da;
  padding: 6px 10px 5px 35px !important;
  border-radius: 0.5rem;
  height: 2.5rem;
  font-weight: 600;
  background: transparent;
  cursor: pointer;
}

.dark .soft-datepicker {
  color: white;
}

.react-datepicker__input-container {
  width: 100%;
  display: flex;
  align-items: center;
}

.dark .react-datepicker__input-container > svg {
  color: white;
}

.react-datepicker-popper {
  z-index: 100;
}

.react-datepicker__close-icon::after {
  background-color: var(--blue);
}

.react-datepicker__day--selected {
  background-color: var(--blue);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/custom/StyledDatePicker.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".soft-datepicker {\n  border: 0.0625rem solid #d2d6da;\n  padding: 6px 10px 5px 35px !important;\n  border-radius: 0.5rem;\n  height: 2.5rem;\n  font-weight: 600;\n  background: transparent;\n  cursor: pointer;\n}\n\n.dark .soft-datepicker {\n  color: white;\n}\n\n.react-datepicker__input-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.dark .react-datepicker__input-container > svg {\n  color: white;\n}\n\n.react-datepicker-popper {\n  z-index: 100;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: var(--blue);\n}\n\n.react-datepicker__day--selected {\n  background-color: var(--blue);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
